export default "__VITE_ASSET__5e4e98cf__"